import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 } from '@atlassian/jira-intl/src/v2/types.tsx';
import {
	EPIC_LINK,
	SPRINT,
	FIX_VERSION,
	AFFECTED_VERSION,
	PARENT,
	ASSIGNEE,
	REPORTER,
	CREATOR,
	COMPONENT,
} from '../../common/constants.tsx';

export const messages: {
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[ASSIGNEE.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[REPORTER.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[CREATOR.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[COMPONENT.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[PARENT.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[FIX_VERSION.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[AFFECTED_VERSION.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[EPIC_LINK.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[SPRINT.searchTemplate]: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	genericEmpty: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// eslint-disable-next-line jira/i18n/id-named-by-package
	'epic link': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sprint: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[ASSIGNEE.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.assignee',
		defaultMessage: 'Unassigned',
		description:
			'Label for option to select unassigned issues in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[REPORTER.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.reporter-new',
		defaultMessage: 'Anonymous',
		description:
			'Label for option to select issues with an anonymous reporter in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[CREATOR.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.creator',
		defaultMessage: 'Anonymous',
		description:
			'Label for option to select issues with an anonymous creator in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[COMPONENT.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.components',
		defaultMessage: 'No component',
		description:
			'Label for option to select issues with an empty component field value in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[PARENT.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.parent',
		defaultMessage: 'No parent',
		description:
			'Label for option to select issues with an empty parent field value in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[FIX_VERSION.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.fix-versions',
		defaultMessage: 'No version',
		description:
			'Label for option to select issues with an empty fix version field value in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[AFFECTED_VERSION.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.versions',
		defaultMessage: 'No version',
		description:
			'Label for option to select issues with an empty affected version field value in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher': {
		id: 'jql-builder-basic.utils.get-empty-label.custom-versions',
		defaultMessage: 'No version',
		description:
			'Label for option to select issues with an empty custom version field value in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[EPIC_LINK.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.epic-link-new',
		defaultMessage: 'No epic link',
		description:
			'Label for option to select issues with an empty epic link field value in issue navigator refinement dropdown.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	[SPRINT.searchTemplate]: {
		id: 'jql-builder-basic.utils.get-empty-label.sprint-new',
		defaultMessage: 'No sprint',
		description:
			'Label for option to select issues wiht an empty sprint field value in issue navigator refinement dropdown.',
	},
	genericEmpty: {
		id: 'jql-builder-basic.utils.get-empty-label.generic-empty',
		defaultMessage: 'Empty',
		description:
			"Label for option to select issues with an empty field value in issue navigator refinement dropdown. This option is used as a fallback when we don't have a field-specific translation.",
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package
	'epic link': {
		id: 'jql-builder-basic.utils.get-empty-label.epic-link',
		defaultMessage: 'No epic link',
		description:
			'Label for option to select issues with an empty epic link field value in issue navigator refinement dropdown.',
	},
	sprint: {
		id: 'jql-builder-basic.utils.get-empty-label.sprint',
		defaultMessage: 'No sprint',
		description:
			'Label for option to select issues wiht an empty sprint field value in issue navigator refinement dropdown.',
	},
});

// Used to dynamically lookup message descriptors while keeping TS happy.
export const messageLookup: { [key: string]: MessageDescriptorV2 | undefined } = messages;
